import { $httpChangiRecommends } from '@/core/api';
const state = {
    itemsWishlist: [],
    allItems: [],
    removeItems: [],
    loaded: false,
    loading: false,
    isProductOnWishlist: false,
    productNameToWishlist: '',
    loadingByUuid: {},
};
const mutations = {
    setLoading(state, loading) {
        state.loading = loading;
    },
    // set/unset loading for a particular product uuid
    setItemLoading(state, payload) {
        const { uuid, value } = payload;
        // ensure reactivity
        state.loadingByUuid = { ...state.loadingByUuid, [uuid]: value };
    },
    setLoaded(state, loaded) {
        state.loaded = loaded;
    },
    setIsProductOnWishlist(state, isProductOnWishlist) {
        state.isProductOnWishlist = isProductOnWishlist;
    },
    setItemsWishlist(state, itemsWishlist) {
        state.itemsWishlist = itemsWishlist;
    },
    setAllItems(state, allItems) {
        state.allItems = allItems;
    },
    setRemoveItems(state, removeItems) {
        state.removeItems = removeItems;
    },
    setProductNameToWishlist(state, productNameToWishlist) {
        state.productNameToWishlist = productNameToWishlist;
    },
};
const actions = {
    addToWishList({ commit }, payload) {
        commit('setLoading', true);
        $httpChangiRecommends.api
            .ChangiRecommendsAddToWishlist(payload)
            .then((response) => {
            commit('setItemsWishlist', response.data);
            commit('setLoaded', true);
        })
            .catch((err) => {
            console.log(err);
            commit('setLoaded', false);
        })
            .finally(() => {
            commit('setLoaded', false);
            commit('setLoading', false);
        });
    },
    getWishList({ commit }) {
        $httpChangiRecommends.api.ChangiRecommendsGetWishlistItems().then((response) => {
            commit('setAllItems', response.data);
            commit('setItemsWishlist', response.data);
        }).catch((err) => {
            $httpChangiRecommends.api.ChangiRecommendsGetWishlistItems().then((response) => {
                commit('setAllItems', response.data);
                commit('setItemsWishlist', response.data);
            }).catch((err) => {
                console.log(err);
                commit('setLoaded', false);
                commit('setLoading', false);
            });
        });
    },
    removeWishlistItem({ commit }, payload) {
        commit('setLoading', true);
        $httpChangiRecommends.api
            .ChangiRecommendsRemoveWishlistItem(payload)
            .then((response) => {
            commit('setRemoveItems', response.data);
            commit('setLoaded', true);
            commit('setItemsWishlist', response.data);
            commit('setAllItems', response.data);
        })
            .catch((err) => {
            console.log(err);
            commit('setLoaded', false);
            commit('setLoading', false);
        })
            .finally(() => {
            commit('setLoaded', false);
            commit('setLoading', false);
        });
    },
};
const getters = {
    isOnWishlist: (state) => {
        return (productUuid) => {
            let productsOnWishlistUuidArray = state.itemsWishlist.map((item) => {
                return item.product?.uuid;
            });
            let specificProductUuid = productsOnWishlistUuidArray.find((item) => {
                return item == productUuid;
            });
            return specificProductUuid == productUuid;
        };
    },
    isUnitOnWishlist: (state) => {
        return (unitUuid) => {
            let productsOnWishlistUuidArray = state.itemsWishlist.map((item) => {
                return item.unit_uuid;
            });
            let specificProductUuid = productsOnWishlistUuidArray.find((item) => {
                return item == unitUuid;
            });
            return specificProductUuid == unitUuid;
        };
    },
};
export const wishlistModule = {
    state,
    mutations,
    actions,
    namespaced: true,
    getters,
};
